import { resiLicenses } from './resi-licenses';

export const externals = {
  resiLicenses,
};
